/* Denimaxx: mobile "Read more" (v15, 2026-10-14). Collection + product description TEXT only.
   Never on pages (/pages/*). Tiles/images/tables/link grids inside a description are never hidden:
   only the leading text-only paragraphs get collapsed. Full text stays in HTML for SEO. */
(function(){
var SEL='.collection__description, .product-single__meta .product-block > .rte, .product-single__description';
var SKIP='.collapsible-content, .collapsible-content__inner, .product__policies, footer, .site-footer, .modal, .drawer, form, .newsletter, .site-header, .grid-product';
var RICH='img, picture, video, iframe, table, form, input, [class*="grid"], [style*="grid"], [style*="flex"]';
function isPage(){var b=document.body;return !b||b.classList.contains('template-page')||/^\/pages\//.test(location.pathname);}
function rich(el){if(el.nodeType!==1)return false;if(el.matches(RICH)||el.querySelector(RICH))return true;return el.querySelectorAll('a').length>=3&&el.textContent.trim().length<200;}
function target(d){
  if(!d.querySelector(RICH)&&!Array.prototype.some.call(d.children,rich))return d;
  var nodes=[],n=d.firstChild;
  while(n){if(n.nodeType===1&&(rich(n)||n.tagName==='STYLE'||n.tagName==='SCRIPT'))break;nodes.push(n);n=n.nextSibling;}
  if(!nodes.some(function(x){return x.textContent.trim();}))return null;
  var w=document.createElement('div');w.className='dmx-text';d.insertBefore(w,nodes[0]);nodes.forEach(function(x){w.appendChild(x);});
  return w;}
function init(){if(!window.matchMedia('(max-width:768px)').matches||isPage())return;
document.querySelectorAll(SEL).forEach(function(d){
 if(d.dataset.dmx)return;if(d.matches(SKIP)||d.closest(SKIP))return;
 if(d.parentElement&&d.parentElement.closest('[data-dmx]'))return;
 d.dataset.dmx=1;var t=target(d);if(!t||t.scrollHeight<180)return;
 t.classList.add('dmx-clamp');
 var b=document.createElement('button');b.type='button';b.className='dmx-readmore';b.textContent='Read more';b.setAttribute('aria-expanded','false');
 b.onclick=function(){var o=t.classList.toggle('dmx-clamp');b.textContent=o?'Read more':'Read less';b.setAttribute('aria-expanded',String(!o));};
 t.after(b);});}
if(document.readyState!='loading')init();else document.addEventListener('DOMContentLoaded',init);
window.addEventListener('load',init);document.addEventListener('collection:reloaded',init);})();

/* Denimaxx: PDP color lock (v19, 2026-10-15).
   1) Explicit ?variant= ALWAYS wins — never override with featured-image matching.
   2) If URL has no variant, pick the variant whose image matches the product featured image
      so bare /products/handle links from any source still open on the tile color.
   Swatch hover no longer rewrites collection card links (removed in v19). */
(function(){
function isProduct(){return /^\/products\//.test(location.pathname);}
function fileBase(url){
  if(!url)return '';
  return String(url).split('?')[0].split('/').pop().replace(/_\d+x(?=\.)/,'');
}
function parseVariants(){
  var el=document.querySelector('[data-variant-json]');
  if(!el)return [];
  try{return JSON.parse(el.textContent||el.innerText);}catch(e){return [];}
}
function featuredSrc(){
  var og=document.querySelector('meta[property="og:image"]');
  if(og&&og.content)return og.content;
  var img=document.querySelector('.product-main-slide img, .product__main-photos img, .product-image-main img');
  return img?(img.currentSrc||img.src):'';
}
function findTargetVariant(variants){
  var params=new URLSearchParams(location.search);
  var vid=params.get('variant');
  if(vid){
    for(var i=0;i<variants.length;i++){if(String(variants[i].id)===String(vid))return variants[i];}
    return null; /* explicit ?variant= present but unknown — do not fall back to featured */
  }
  var feat=fileBase(featuredSrc());
  if(!feat)return null;
  var match=null;
  for(var j=0;j<variants.length;j++){
    var v=variants[j];
    var src=(v.featured_image&&v.featured_image.src)||'';
    if(src&&fileBase(src)===feat){
      match=v;
      if(v.available)return v;
    }
  }
  return match;
}
function selectVariant(variant){
  if(!variant)return false;
  var changed=false;
  var opts=[variant.option1,variant.option2,variant.option3];
  for(var i=0;i<opts.length;i++){
    var val=opts[i];
    if(val==null||val==='')continue;
    var index='option'+(i+1);
    var radios=document.querySelectorAll('input[data-variant-input][data-index="'+index+'"]');
    if(!radios.length)continue;
    var target=null;
    radios.forEach(function(r){if(r.value===val)target=r;});
    if(target&&!target.checked){
      target.checked=true;
      target.dispatchEvent(new Event('change',{bubbles:true}));
      target.dispatchEvent(new Event('click',{bubbles:true}));
      changed=true;
    }
  }
  // Only write ?variant= when the URL had none (bare URL recovery). Never rewrite an explicit ?variant=.
  var params=new URLSearchParams(location.search);
  if(!params.get('variant')&&window.history&&history.replaceState){
    var newurl=location.protocol+'//'+location.host+location.pathname+'?variant='+variant.id;
    history.replaceState({path:newurl},'',newurl);
  }
  return changed;
}
function apply(){
  if(!isProduct())return;
  var variants=parseVariants();
  if(!variants.length)return;
  var target=findTargetVariant(variants);
  if(!target)return;
  // If radios already match, still ensure URL has variant
  var colorRadio=document.querySelector('input[data-variant-input][data-index="option1"]:checked');
  if(colorRadio&&colorRadio.value===target.option1){
    var params=new URLSearchParams(location.search);
    if(!params.get('variant')&&window.history&&history.replaceState){
      var newurl=location.protocol+'//'+location.host+location.pathname+'?variant='+target.id;
      history.replaceState({path:newurl},'',newurl);
    }
    return;
  }
  selectVariant(target);
}
function boot(){
  apply();
  // Beat Impulse theme init / dynamic variant availability races
  setTimeout(apply,300);
  setTimeout(apply,1000);
  setTimeout(apply,2500);
}
if(document.readyState!='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
window.addEventListener('load',function(){setTimeout(apply,100);});
})();
